import { render, staticRenderFns } from "./kdxTagLabel.g.vue?vue&type=template&id=c36ec492&scoped=true"
import script from "./kdxTagLabel.g.vue?vue&type=script&lang=js"
export * from "./kdxTagLabel.g.vue?vue&type=script&lang=js"
import style0 from "./kdxTagLabel.g.vue?vue&type=style&index=0&id=c36ec492&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c36ec492",
  null
  
)

export default component.exports